import React from 'react';
import VideoPlayerJs from './videojs/VideoPlayerJs';
import { useSearchParams } from 'react-router-dom';


const VideoPageVideoJs = () => {

  const [searchParams] = useSearchParams();
  const videoIdsParam = searchParams.get('videoIds')
  const backendApiUrl = process.env.REACT_APP_BACKEND_API_URL;

  const videoIds = videoIdsParam ? videoIdsParam.split(',') : [];

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="max-w-xl w-full shadow-lg rounded-lg bg-white p-6">
        <h1 className="text-2xl font-bold text-center mb-4">Videos using videojs player</h1>
        <h1 className="text-2xl font-bold text-center mb-4">Playing </h1>
        <div className="aspect-w-16 aspect-h-9">
          <VideoPlayerJs
            videoIds={videoIds}
          />
        </div>
      </div>
    </div>
  );
};

export default VideoPageVideoJs;
